import React, {} from 'react'
import DragAndDrop from "../../DragAndDrop";
import Grid from "@mui/material/Grid";
import {Typography} from "@material-ui/core";
import {TextField} from "@mui/material";
import Button from "@mui/material/Button";
import Enums from "../../General/Enums";
import "../CV.css"
import {useLocation} from "react-router-dom";
import ApplicationInformation from "../ApplicationInformation";
import ApplicationJobCard from "../ApplicationJobCard";

export default function ApplicationLandingPage({jobTitle, cvUploaded, handleNext, job, jobResponsibilities}) {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const application = searchParams.get('application');

    const handleManualClick = function (event) {
        handleNext(event);
    }

    return (
        <Grid container data-testid={"applicationLandingPage"} direction={"row"} spacing={2} padding={2}
              justifyContent={"flex-start"} alignContent={"center"}>

            <Grid item xs={12}>
                {job && job.jobDetails ? (
                    application !== null ? (
                        <ApplicationJobCard job={job} />
                    ) : (
                        <ApplicationInformation job={job} jobResponsibilities={jobResponsibilities}/>
                    )
                ) : null}
            </Grid>

            <Grid item xs={12} hidden={true}>
                <Typography variant={"h6"} style={{marginBottom: '1%', marginLeft: '6%'}}>Introduce
                    yourself</Typography>
                <TextField label="Capture cover letter"
                           multiline
                           minRows={4}
                           sx={Enums.textFieldStyle}
                           style={{width: "71%", left: "6%"}}>
                </TextField>
            </Grid>


            <Grid item xs={12}>
                <Typography style={{marginLeft: "6%"}} variant={"h6"}>Please upload your CV below</Typography>

                <DragAndDrop inputUpdated={cvUploaded}/>

                <Button id={"createCvManual"} onClick={handleManualClick} variant={"outlined"}
                        style={{left: "6%", color: '#FF6600', borderColor: '#FF6600',}} data-testid={"create-manual"}>
                    Apply Manually
                </Button>
            </Grid>
        </Grid>

    )
}